const gql = require('graphql-tag')

export default gql`query report_project_hours_worked_total($month: Int, $year: Int, $office_id: Int){
  report_project_hours_worked_total(month: $month, year: $year, office_id: $office_id){
    project_id
    name
    office
    hours_worked,
    user_breakdown{
      user_name
      hours_worked
    }
  }
}`